<template>
    <div>
        <Menu/>
        <div class="banner">
            <img class="icn_great" src="../assets/greatplace.png" alt="great place">
            <b-container>
                <b-row>
                    <b-col md="8" offset-md="2">
                        <h3>Nuestra certificación <b>Great Place to Work®</b> refleja nuestro compromiso con el bienestar de nuestro equipo y la creación de un entorno donde los sueños se hacen realidad.</h3>
                        <p>Nos dedicamos a ser congruentes con nuestros valores, construyendo una cultura que nos posiciona como una de las mejores compañías para trabajar.</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="text-center">
                        <img class="img-fluid" src="../assets/bolsa-de-trabajo/collage.png" alt="collage">
                        <a href="#" class="btn btn-banner">Enviar mensaje</a>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="beneficios">
            <img src="../assets/bolsa-de-trabajo/circles4.png" class="img-circles" alt="">
            <b-container>
                <b-row class="mb-5">
                    <b-col md="8">
                        <span class="hightlight-light">Beneficios</span>
                        <h3 class="mb-3 mt-3">Nuestro activo más valioso para el crecimiento sostenible son las personas.</h3>
                        <p>Contratamos a los mejores porque nos hacen mejores. Buscamos talento como el tuyo, personas dedicadas que prosperen en nuestra cultura y se conviertan en una parte integral de nuestra ventaja competitiva.</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="mb-5" md="4">
                        <div class="wrapperimage">
                            <img src="../assets/bolsa-de-trabajo/Iconserviciomedico.png" alt="icon">
                        </div>
                        <p class="strong">Servicio médico</p>
                        <p>Servicios médicos, psicológicos y nutriólogos disponibles 24/7, atención integral de salud en cualquier momento del día.</p>
                    </b-col>
                    <b-col class="mb-5" md="4">
                        <div class="wrapperimage">
                            <img src="../assets/bolsa-de-trabajo/iconbecaescolar.png" alt="icon">
                        </div>
                        <p class="strong">Becas escolares</p>
                        <p>Becas en institución privada o pública, en línea o presencial. Apoyo financiero para la educación de los colaboradores y sus familias.</p>
                    </b-col>
                    <b-col class="mb-5" md="4">
                        <div class="wrapperimage">
                            <img src="../assets/bolsa-de-trabajo/iconexcelencia.png" alt="icon">
                        </div>
                        <p class="strong">Bonos por excelencia</p>
                        <p>Reconocimiento económico por desempeño excepcional.</p>
                    </b-col>
                    <b-col class="mb-5" md="4">
                        <div class="wrapperimage">
                            <img src="../assets/bolsa-de-trabajo/iconpermanencia.png" alt="icon">
                        </div>
                        <p class="strong">Bono de permanencia</p>
                        <p>Recompensa económica por lealtad y continuidad en la empresa.</p>
                    </b-col>
                    <b-col class="mb-5" md="4">
                        <div class="wrapperimage">
                            <img src="../assets/bolsa-de-trabajo/iconoresultdodeventa.png" alt="icon">
                        </div>
                        <p class="strong">Bono por resultado de venta</p>
                        <p>Incentivo económico basado en los logros de venta.</p>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="cultura">
            <b-container fluid>
                <b-row>
                    <b-col class="text-center mb-3" md="8" offset-md="2">
                        <span class="hightlight">Cultura Ctrendy</span>
                        <h3 class="mb-3 mt-3">En Ctrendy, nuestra cultura fomenta el<br> crecimiento, la innovación y el respeto.</h3>
                        <p>Somos una comunidad apasionada y comprometida,<br>
                            guiada por valores que impulsan nuestro éxito y satisfacción.</p>
                    </b-col>
                </b-row>
                <b-row class="desktop">
                    <img class="img-fluid collage" src="../assets/bolsa-de-trabajo/collage_bolsa.png" alt="">
                </b-row>
                <b-row class="mobile">
                    <b-col class="mb-3" md="3">
                        <img class="img-fluid mb-3" src="../assets/bolsa-de-trabajo/cultura1.png" alt="image cultura">
                        <img class="img-fluid" src="../assets/bolsa-de-trabajo/cultura2.png" alt="image cultura">
                    </b-col>
                    <b-col class="mb-3" md="3">
                        <img class="img-fluid" src="../assets/bolsa-de-trabajo/cultura3.png" alt="image cultura">
                    </b-col>
                    <b-col class="mb-3" md="3">
                        <img class="img-fluid" src="../assets/bolsa-de-trabajo/cultura4.png" alt="image cultura">
                    </b-col>
                    <b-col class="mb-3" md="3">
                        <img class="img-fluid mb-3" src="../assets/bolsa-de-trabajo/cultura5.png" alt="image cultura">
                        <img class="img-fluid" src="../assets/bolsa-de-trabajo/cultura6.png" alt="image cultura">
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="liderazgo">
            <b-container class="text-center">
                <b-row class="mb-3">
                    <b-col md="10" offset-md="1">
                        <span class="hightlight">Liderazgo</span>
                        <h3 class="mb-3 mt-3">Nuestro equipo es el motor
                            que impulsa nuestra excelencia.</h3>
                        <p>Formado por personas talentosas y dedicadas, cada miembro aporta su pasión y experiencia para crear un impacto positivo. Descubre las historias y talentos que hacen de Ctrendy una familia única y extraordinaria.</p>
                    </b-col>
                </b-row>
                <b-row class="members">
                    <b-col class="mb-4" md="4">
                        <img class="img-fluid" src="../assets/bolsa-de-trabajo/img1.png" alt="">
                        <p>Juan Glenn</p>
                        <p class="blue">Visionario</p>
                    </b-col>
                    <b-col class="mb-4" md="4">
                        <img class="img-fluid" src="../assets/bolsa-de-trabajo/img2.png" alt="">
                        <p>Everardo Rousse</p>
                        <p class="blue">Integrador</p>
                    </b-col>
                    <b-col class="mb-4" md="4">
                        <img class="img-fluid" src="../assets/bolsa-de-trabajo/img3.png" alt="">
                        <p>Vanessa Guerrero</p>
                        <p class="blue">Gerente Administrativo</p>
                    </b-col>
                    <b-col class="mb-4 ml-auto" md="4">
                        <img class="img-fluid" src="../assets/bolsa-de-trabajo/img4.png" alt="">
                        <p>Cesar Montiel</p>
                        <p class="blue">Gerente de Ventas</p>
                    </b-col>
                    <b-col class="mb-4 mr-auto" md="4">
                        <img class="img-fluid" src="../assets/bolsa-de-trabajo/img5.png" alt="">
                        <p>Diana Guevara</p>
                        <p class="blue">Gerente de Operaciones</p>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="form text-center">
            <b-container>
                <b-row>
                    <b-col>
                        <span class="hightlight">Envíanos un mensaje</span>
                        <div class="mt-4 form-wrapper">
                            <h3 class="mb-5">Forma parte de<br> nuestro equipo</h3>
                            <p class="sendText">{{ messageSend }}</p>
                            <b-container>
                                <b-row>
                                    <b-col md="6" class="mb-3 form-floating">
                                        <b-form-input id="input-1" v-model="c_name" placeholder="Name*" type="text"></b-form-input>
                                        <label for="input-1">Nombre</label>
                                    </b-col>
                                    <b-col md="6" class="mb-3 form-floating">
                                        <b-form-input id="input-2" v-model="c_email" placeholder="Email*" type="text"></b-form-input>
                                        <label for="input-2">Correo electrónico</label>
                                        <img class="vector" src="../assets/bolsa-de-trabajo/Vector7.svg">
                                    </b-col>
                                    <b-col md="6" class="mb-3 form-floating">
                                        <b-form-input id="input-3" v-model="c_phone" placeholder="Phone*" type="text"></b-form-input>
                                        <label for="input-3">Número de teléfono</label>
                                    </b-col>
                                    <b-col md="6" class="mb-3 form-floating">
                                        <b-form-input id="input-2" v-model="c_company" placeholder="Empresa*" type="text"></b-form-input>
                                        <label for="input-2">Empresa</label>
                                    </b-col>
                                    <b-col md="12" class="mb-3"> 
                                        <b-form-textarea id="input-3" v-model="c_message" placeholder="Mensaje" rows="6" max-rows="3"></b-form-textarea>
                                    </b-col>
                                    <b-col class="wrapper-cvu mb-3" md="12">
                                        <b-form-file
                                            v-model="cvuFile"
                                            placeholder="Adjunta tu CV aquí para cargar o haz clic aquí para buscar. Tamaño máximo del archivo 10MB."
                                            drop-placeholder="Suelta tu archivo aquí"
                                        ></b-form-file>
                                    </b-col>
                                </b-row>
                            </b-container>
                            
                            <b-form-input autocomplete="off" tabindex="-1" id="input-1" class="pet-field" v-model="pet" placeholder="Alimento de mascota" type="text"></b-form-input>
                            <b-button class="btn btn-clients mt-4" v-on:click="sendMessage">Enviar mensaje</b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import Menu from '../components/Menu.vue'
    import Footer from '../components/Footer.vue'
    import axios from 'axios'
    export default {
        name: 'Job',
        components: {
            Menu,
            Footer
        },
        data() {
            return {
                c_name: '',
                c_email: '',
                c_phone: '',
                c_company: '',
                c_message: '',
                cvuFile: '',
                pet:'',
            }
        },
        methods: {
            async sendMessage(){
                if (    this.c_name &&
                        this.c_email &&
                        this.c_phone &&
                        this.cvuFile
                ) { 
                    if(((this.cvuFile.size/1024)/1024)>10){
                        let formData = new FormData()
                        var responseData 
                        formData.append('name', this.c_name)
                        formData.append('email', this.c_email)
                        formData.append('phone', this.c_phone)
                        formData.append('company', this.c_company)
                        formData.append('message', this.c_message)
                        formData.append('cvuFile', this.cvuFile)
                        await axios
                        .post(
                            'vendor/send-cvu.php',
                            formData,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            },
                        )
                        .then((response) => {
                            responseData = response.data
                        })
                        .catch((error) => {
                            /* eslint-disable no-console */
                            console.log(error);
                            /* eslint-enable no-console */
                        });
                        
                        if(responseData==200 || responseData=='200') {
                                this.c_name = ''
                                this.c_email = ''
                                this.c_phone = ''
                                this.c_company = ''
                                this.c_message = '' 
                                this.messageSend = 'Mensaje enviado.'
                        } else {
                            this.messageSend = 'Error al enviar mensaje, intenta mas tarde.'
                        }
                    }else {
                        this.messageSend = 'Tamaño máximo del archivo ess 10MB'
                    }
                } else {
                    this.messageSend = 'Ingresa la información necesaria en los campos.'
                }
            }
        }
    }
</script>

<style scoped>
h3{
  font-size: 35px;
  font-weight: 400;
}
p{
    font-size: 20px;
    line-height: 25px;
}
.ml-auto{
    margin-left: auto;
}
.mr-auto{
    margin-right: auto;
}
/* BANNER */
.banner{
    padding-top: 250px;
    padding-bottom: 100px;
    text-align: center;
    position: relative;
}
.icn_great{
    position: absolute;
    top: 135px;
    right: 10%;
}

.banner .btn{
    color: #000 !important;
    font-size: 25px;
    background: #03DBE1 !important;
    padding: 15px;
    width: 100%;
    max-width: 285px;
}

/* BENEFICIOS */
.beneficios{
    background:#001824;
    padding: 125px 0;
    color: #fff;
    position: relative;
}
.beneficios p{
    font-size: 18px;
}
.beneficios .strong{
    margin-bottom: 0px;
    font-weight: 600;
    font-size: 20px;
}
.beneficios .wrapperimage{
    height: 100px;
}

.img-circles{
    position: absolute;
    top: 0;
    right: 0;
}

/* CULTURA */
.cultura{
    padding: 100px 0; 
}
.mobile{
    display: none;
}
.desktop{
    display: block;
    padding:0;
}
.desktop img{
    width: 100%;
    padding: 0;
}

/* LIDERAZGO */
.liderazgo{
   max-width: 1043px;
   margin-left: auto;
   margin-right: auto; 
}
.liderazgo .members img{
    margin-bottom: 20px;
    max-width: 295px;
}

.liderazgo .members p{
    margin-bottom: 0px;
}
.liderazgo .members p.blue{
    font-size: 18px;
    color: #386CE7;
}

/* FORM */
.form{
    max-width: 1043px;
    margin-left: auto;
    margin-right: auto; 
    padding: 200px 0;
}
.form-wrapper{
    background: #16B7C2;
    border-radius: 20px;
    padding: 65px 100px;
}
/* FORM */
.vector{ 
    position: absolute;
    right: -50px;
    top:-50px;
    z-index: 0;
}
.btn-clients{
    width: 100%; 
    color: #fff !important;
    font-size: 25px;
    background: #FC5300 !important;
    border: none;
    padding: 10px;
    max-width: 285px;
}
.form-floating{
    position: relative;
}

.form-floating > .form-control{
    background: #fff;
    border: none;
    border-radius: 5px;
    color: #000;
    font-size: 18px;
    outline: none !important;
    padding-left: 20px;
    position: relative;
    z-index: 2;
}

.form-floating > .form-control:focus ~ label, .form-floating > .form-control:not(:placeholder-shown) ~ label, .form-floating > .form-control-plaintext ~ label, .form-floating > .form-select ~ label {
    color: rgba(0,0,0, 0.4) !important; 
    -webkit-transform: scale(0.65) translateY(-0.5rem) translateX(0rem);
    transform: scale(0.65) translateY(-0.5rem) translateX(0rem);
    left: 20px;
}

label{
    color: #000;
    font-size: 18px;
}
textarea{
    background: #fff;
    border-radius: 5px;
    border: none;
    outline: none;
    font-size: 18px;
    color: #000;
    padding-left: 20px;
}
input:focus,
input:active{
    outline: none !important;
    box-shadow: none !important;
}
.form-floating label{
    font-size: 18px;
    color: #000 !important;
    padding-left: 20px;
    left: 10px;
    z-index: 3;
}
.form-floating > .form-control:focus ~ label::after, .form-floating > .form-control:not(:placeholder-shown) ~ label::after, .form-floating > .form-control-plaintext ~ label::after, .form-floating > .form-select ~ label::after{
    background: transparent;
    color: #000 !important;
}

.pet-field{
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 0;
    z-index: -1;
}

.custom-file-input{
    visibility: hidden;
}

.custom-file-label {
    white-space: normal;
    overflow-x: hidden;
    width: 100%;
    background: white;
    padding: 50px 10px;
    border: 2px #386CE7 dashed;
    border-radius: 10px;
}

.custom-file-input{
    visibility: hidden;
}

.sendText{
    font-size: 16px;
    font-weight: 700;
}

@media (max-width: 768px){
    h3{
        font-size: 27px;
        line-height: 1;
        font-weight: 400;
    }
    p, ul{
        font-size: 18px;
        line-height: 20px;
    }


    /* BANNER */
    .banner{
        padding-top: 150px;
        padding-left: 7%;
        padding-right: 7%;
    }
    .icn_great{
        display: none;
    }

    .banner .btn{
        font-size: 20px;
        margin-top: 20px;
    }

    /* BENEFICIOS */
    .beneficios{
        background:#386CE7;
        padding: 85px 7%;
        color: #fff;
        position: relative;
    }
    .beneficios p{
        font-size: 18px;
    }
    .beneficios .strong{
        margin-bottom: 0px;
        font-weight: 600;
        font-size: 20px;
    }
    .beneficios .wrapperimage{
        height: 100px;
    }

    .img-circles{
        position: absolute;
        top: 0;
        right: 0;
        width: 50%;
    }

    /* CULTURA */
    .cultura{
        padding: 100px 7%; 
    }

    .mobile{
        display: block;
    }
    .mobile img{
        border-radius: 20px;
    }
    .desktop{
        display: none;
    }

    /* LIDERAZGO */
    .liderazgo{
        max-width: 1043px;
        margin-left: auto;
        margin-right: auto; 
    }
    .liderazgo .members img{
        margin-bottom: 20px;
        max-width: 295px;
    }

    .liderazgo .members p{
        margin-bottom: 0px;
    }
    .liderazgo .members p.blue{
        font-size: 18px;
        color: #386CE7;
    }

    /* FORM */
    .form{
        max-width: 1043px;
        margin-left: auto;
        margin-right: auto; 
        padding: 50px 0;
    }
    .form-wrapper{
        background: #B7EFFF;
        border-radius: 20px;
        padding: 65px 7%;
    }
    /* FORM */
    .vector{ 
        display: none;
    }
    .btn-clients{
        font-size: 20px;
    }

}

</style>